<template>
    <div class="cardContainer">
        <van-row v-if="isShowDetails">
            <van-col span="3" class="calanderImage">
                <img src="@/assets/themeFour/calander.png" alt="" width="80%">
            </van-col>
            <van-col span="12" class="topRow">
                <div class="dayTitle">{{ $t('activity.transactionDate') }}: <span style="color: #e2ffda;">{{
                    createTime?.split(' ')[0]
                        }}</span></div>
                <div class="valueText">
                    <span style="font-weight: 100;color: #ffffff99;">{{ title }}: </span> {{ formatCurrency(totalAmount) }}
                </div>
            </van-col>
            <van-col span="9" class="topRow">
                <div class="dayTitle">{{ $t('activity.cashBackTotal') }}:</div>
                <div class="valueText">{{ dayList ? formatCurrency(getAmountSum(dayList)) : formatCurrency(0) }}</div>
            </van-col>
        </van-row>
        <div class="glowing-line" v-if="isShowDetails"></div>

        <van-row v-if="!isShowDetails">
            <van-col span="7" class="dayColumn">
                <div class="dateText" style="font-size: 14px;">{{ createTime?.split(' ')[0] }}
                </div>
            </van-col>
            <van-col span="17" class="topRow" style="margin-bottom: 5px;">
                <div class="dayTitle" style="font-size: 16px;">{{ $t('activity.givenAmount') }} :
                    <span style="padding-left: 10px;color: #e2ffda;font-weight: bold;">{{ formatCurrency(givenAmount)
                    }}</span>
                </div>
                <van-row>
                    <van-col span="24" v-if="currentStatus" class="dayTitle statusBorder" :style="{
                        '--status-color': currentStatus.color,
                        '--status-glow': currentStatus.glow
                    }">
                        <span class="statusRow" :style="{ color: 'var(--status-color)' }">
                            <van-icon :name="currentStatus.icon" size="15px" :color="'var(--status-color)'" />
                            &nbsp;
                            <span style="font-weight: bold;">{{ $t(currentStatus.text) }}</span>
                        </span>
                    </van-col>
                </van-row>
            </van-col>
        </van-row>
        <van-row v-if="isShowDetails" style="margin-top: 10px; display: flex; justify-content: center;"
            justify="space-between">
            <van-col span="12" v-for="(i, index) in dayList" :key="index">
                <div
                    :style="{ color: checkDate(i.date) == 0 && istodayClaimed ? '#36d836' : checkDate(i.date) <= 0 ? 'gray' : '' }">
                    <div class="detailedCardContent">
                        <van-icon name="point-gift" color="#05a78c" size="16px" style="padding-right: 3px;" />
                        {{ (dayFormat(i.date, 0)) }}:
                        <span style="color:#e2ffda;padding: 0 3px;">{{ formatCurrency(i.amount) }}</span>
                    </div>
                </div>
            </van-col>
            <van-col span="24" class="dayTitle statusBorder" :style="{
                '--status-color': currentStatus.color,
                '--status-glow': currentStatus.glow, 'margin-bottom': '5px'
            }" v-if="dayList?.length <= 0 || !dayList">
                <span class="statusRow" :style="{ color: 'var(--status-color)' }">
                    <span style="color: #e2ffda;">{{ $t('activity.status') }} :</span>
                    &nbsp;
                    <span style="font-weight: bold;">{{ $t(currentStatus.text) }}</span>
                </span>
            </van-col>
        </van-row>
    </div>
</template>
<script lang="ts" setup>
import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps({
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
})

type StatusKey = number;
const statusMap: Record<StatusKey, { icon: string; text: string; color: string; glow: string }> = {
    0: { icon: 'underway-o', text: 'activityStatus.pending', color: '#3a86ff', glow: '#3a86ff' },
    1: { icon: 'certificate', text: 'activityStatus.completed', color: '#4caf50', glow: '#4caf50' },
    2: { icon: 'close', text: 'activityStatus.noRewards', color: '#f44336', glow: '#f44336' },
    3: { icon: 'close', text: 'activity.overdue', color: '#f44336', glow: '#f44336' }
};
const currentStatus = computed(() => {
    return statusMap[props.activityStatus as StatusKey];
});

</script>
<style scoped>
.topRow {
    margin: 5px 0;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    align-items: left;
}

.calanderImage {
    display: flex;
    justify-content: center;
    align-items: center;
}

.right-texts {
    text-align: left;
    display: flex;
    justify-content: center;
}

.day-num {
    position: absolute;
    font-size: 20px;
    white-space: nowrap;
    color: #ffdcfbD7;
    text-shadow: -1px -1px 0 #300000, 1px -1px 0 #300000, -1px 1px 0 #300000, 1px 1px 0 #300000;
    z-index: 800;
    font-weight: 700;
    left: 55%;
    top: 25%;
}

.dateText {
    top: 50%;
    padding: 0 0 0 5px;
    font-size: 6px;
    color: #e2ffda;
}

.dayImage img {
    width: 80%;
    padding: 0 0 5px;
    position: relative;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.dayImage2 img {
    width: 75px;
    height: 50px;
    position: relative;
}

.dayImage2 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.centerAlignment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.dayCardWrapper {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex: 1;
}

.dayCardWrapper::-webkit-scrollbar {
    display: none;
}

.scrollRow {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 5px;
}

.arrowLeft img {
    width: 10px;
}

.arrowRight {
    position: absolute;
    right: 0px;
}

.arrowLeft {
    position: absolute;
    left: 0px;
}

.arrowRight img {
    width: 10px;
    transform: rotate(180deg);
}

.dayTitle {
    padding-bottom: 5px;
    color: #ffffff99;
}

.statusBorder {
    justify-content: center;
    position: relative;
    padding: 4px 12px;
    background-color: #1a1a1c4a;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    border: 1px solid var(--status-glow);
    background-image:
        radial-gradient(ellipse at center, #f8efef80 0%, transparent 65%),
        linear-gradient(to right, transparent, var(--status-glow) 30%, transparent),
        radial-gradient(ellipse at center, var(--status-glow) 0%, transparent 65%),
        linear-gradient(to right, transparent, var(--status-glow) 30%, transparent);
    background-size:
        45% 25px, 55% 1px,
        45% 25px, 55% 1px,
        1px 40px, 1px 40px;
    background-position:
        top -19px center, top 0px center,
        bottom -20px center, bottom 0px center,
        left 0px center, right 0px center;
    background-repeat: no-repeat;
    box-shadow: 0 0 2px var(--status-glow);
}

.statusRow {
    display: flex;
    align-items: center;
    font-weight: 500;
    justify-content: center;
    font-size: clamp(1rem, 0.95rem + 0.25vw, 1.25rem);
}

.status-pending {
    color: #0484ff;
    border-color: #0484ff;
}

.status-completed {
    color: #36d836;
    border-color: #36d836;
}

.status-noRewards {
    color: #ff0000;
    border-color: #ff0000;
}

.status-overdue {
    color: #ff0000;
    border-color: #ff0000;
}

.rightBorder {
    border-right: 1px solid #80808070;
}

.click_btn {
    color: #12151A;
    font-size: 11.5px;
    background-image: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 50%;
}

.valueText {
    padding: 2px 0 5px;
    font-weight: bold;
    color: #e2ffda;
}

.bottomDayRow {
    display: flex;
    flex-direction: row;
}

@media (min-width:350px) {
    .dateText {
        font-size: 8px;
    }
}

@media (min-width:450px) {
    .dateText {
        font-size: 11px;
    }
}

@media (min-width: 600px) {
    .dateText {
        font-size: 10px;
    }
}

@media (min-width: 1920px) {
    .dateText {
        font-size: 14px;
    }
}

.cardContainer {
    position: relative;
    padding: 3px 8px;
    background: #024a4994;
    border-radius: 10px;
    border: 1px solid #ffffff99;
    color: #ffffff99;
    text-align: left;
    box-sizing: border-box;
    margin: 18px 0px 10px;
    background-image:
        radial-gradient(ellipse at center, #ffffff99 0%, transparent 80%),
        linear-gradient(to right, transparent, #ffffff99 50%, transparent),
        radial-gradient(ellipse at center, #ffffff99 0%, transparent 80%),
        linear-gradient(to right, transparent, #ffffff99 50%, transparent),
        linear-gradient(to bottom, #ffffff99, #ffffff99),
        linear-gradient(to bottom, #ffffff99, #ffffff99);
    background-size:
        45% 25px, 55% 1px,
        45% 25px, 55% 1px,
        1px 40px, 1px 40px;
    background-position:
        top -25px center, top 0px center,
        bottom -25px center, bottom 0px center,
        left 0px center, right 0px center;
    background-repeat: no-repeat;
}

/* Left Notch */
.cardContainer::before {
    content: "";
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 60%;
    background:
        radial-gradient(circle at 0px 5px, #ffffff99 4px, transparent 5px) no-repeat 0 0 / 5px 5px,
        linear-gradient(to bottom,
            #ffffff99 0%,
            rgba(255, 255, 255, 0.804) 50%,
            #ffffff99 100%) no-repeat 0px 5px / 5px calc(100% - 10px),
        radial-gradient(circle at 0px 0px, #ffffff99 4px, transparent 5px) no-repeat 0 100% / 5px 5px;
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.7));
}

/* Right Notch */
.cardContainer::after {
    content: "";
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%) scaleX(-1);
    width: 4px;
    height: 60%;
    background:
        radial-gradient(circle at 0px 5px, #ffffff99 4px, transparent 5px) no-repeat 0 0 / 5px 5px,
        linear-gradient(to bottom,
            #ffffff99 0%,
            rgba(255, 255, 255, 0.804) 50%,
            #ffffff99 100%) no-repeat 0px 5px / 5px calc(100% - 10px),
        radial-gradient(circle at 0px 0px, #ffffff99 4px, transparent 5px) no-repeat 0 100% / 5px 5px;
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.7));
}

.box {
    position: relative;
}

/* Horizantal line near side notches */
.box::before,
.box::after {
    content: "";
    position: absolute;
    top: 25%;
    bottom: 25%;
    width: 1px;

    background: linear-gradient(to bottom,
            #c19a6b0d 0%,
            #c19a6b33 20%,
            #c19a6b64 50%,
            #c19a6b33 80%,
            #c19a6b0d 100%);
}

.box::before {
    left: 0;
}

.box::after {
    right: 0;
}

.glowing-line {
    width: 100%;
    height: 2px;
    position: relative;
    background: linear-gradient(to right,
            rgba(255, 255, 255, 0.01) 0%,
            #ffffff4d 20%,
            #ffffff99 50%,
            #ffffff4d 80%,
            rgba(255, 255, 255, 0.01) 100%);
}

.detailedCardContent {
    font-size: 14px;
    color: #ffffff99;
    display: flex;
    align-items: center;
    padding: 4px 5px;
}
</style>